/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { ReportItem } from 'ng/modules/items/factories';

export type TReportCollection = typeof ReportCollection;

/**
 * @description Report collection
 * @author Deepak Chaudhary
 */
export class ReportCollection extends Collection {
    public static ngDependencies = [
        ReportItem,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'report',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_REPORT,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getNgDependency(ReportItem);
    }
}
